var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main_container" }, [
    _c("div", { staticClass: "draw-part" }, [
      _c("div", { staticClass: "left-draw" }, [
        _c("div", { staticClass: "turntable_box" }, [
          _c(
            "ul",
            { staticClass: "rotate" },
            [
              _vm._l(_vm.awardsList, function(item, index) {
                return _c(
                  "li",
                  {
                    key: item.itemId,
                    staticClass: "award",
                    class: ["award" + index, { active: index == _vm.current }]
                  },
                  [
                    _c(
                      "el-tooltip",
                      { attrs: { placement: "bottom", enterable: false } },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "content" }, slot: "content" },
                          [
                            _c("img", {
                              attrs: { src: item.descriptImgUrl, alt: "" }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "one-prize",
                            class: index == _vm.current ? "mask" : ""
                          },
                          [
                            _c("img", { attrs: { src: item.imgUrl, alt: "" } }),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                _vm._s(item.itemName) +
                                  "X" +
                                  _vm._s(item.amount)
                              )
                            ])
                          ]
                        )
                      ]
                    )
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "start-btn animate-pictrue",
                on: { click: _vm.start }
              })
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "number" }, [
          _c("p", [
            _vm._v("当日剩余抽奖次数: " + _vm._s(this.awardsCount == 0 ? 1 : 0))
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("已抽奖次数: " + _vm._s(this.awardsCount))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "right-prize" }, [
        _c("img", {
          attrs: { src: require("@/assets/images/draw/scale.png"), alt: "" }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "light_box", style: "top:" + _vm.lightHeight + "px" },
          [_c("div", { staticClass: "light" })]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "nav" }, [
          _c("ul", [
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c("li", { class: _vm.pharseDays >= 10 ? "active" : "" }, [
              _c("p", [_vm._v("成圣")])
            ]),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _vm._m(3),
            _vm._v(" "),
            _vm._m(4),
            _vm._v(" "),
            _c("li", { class: _vm.pharseDays >= 6 ? "active" : "" }, [
              _c("p", [_vm._v("大乘")])
            ]),
            _vm._v(" "),
            _vm._m(5),
            _vm._v(" "),
            _vm._m(6),
            _vm._v(" "),
            _c("li", { class: _vm.pharseDays >= 3 ? "active" : "" }, [
              _c("p", [_vm._v("初窥")])
            ]),
            _vm._v(" "),
            _vm._m(7),
            _vm._v(" "),
            _vm._m(8)
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "list" }, [
          _c("ul", [
            _c("li", [
              _c("p", [_vm._v(_vm._s(_vm.phaseListOne.itemName))]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "p-list" },
                [
                  _c(
                    "el-tooltip",
                    { attrs: { placement: "bottom", enterable: false } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "pop-img",
                          attrs: { slot: "content" },
                          slot: "content"
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: _vm.phaseListOne.descriptImgUrl,
                              alt: ""
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("a", { attrs: { href: "#" } }, [
                        _c("img", {
                          attrs: { src: _vm.phaseListOne.imgUrl, alt: "" }
                        })
                      ])
                    ]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _c("p", [_vm._v(_vm._s(_vm.phaseListTwo.itemName))]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "p-list" },
                [
                  _c(
                    "el-tooltip",
                    { attrs: { placement: "bottom", enterable: false } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "pop-img",
                          attrs: { slot: "content" },
                          slot: "content"
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: _vm.phaseListTwo.descriptImgUrl,
                              alt: ""
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("a", { attrs: { href: "#" } }, [
                        _c("img", {
                          attrs: { src: _vm.phaseListTwo.imgUrl, alt: "" }
                        })
                      ])
                    ]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _c("p", [_vm._v(_vm._s(_vm.phaseListThree.itemName))]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "p-list" },
                [
                  _c(
                    "el-tooltip",
                    { attrs: { placement: "bottom", enterable: false } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "pop-img",
                          attrs: { slot: "content" },
                          slot: "content"
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: _vm.phaseListThree.descriptImgUrl,
                              alt: ""
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("a", { attrs: { href: "#" } }, [
                        _c("img", {
                          attrs: { src: _vm.phaseListThree.imgUrl, alt: "" }
                        })
                      ])
                    ]
                  )
                ],
                1
              )
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "my-award" }, [
      _c(
        "ul",
        _vm._l(_vm.myAwardsList, function(item, index) {
          return _c(
            "li",
            { key: index },
            [
              _c("el-tooltip", { attrs: { placement: "bottom" } }, [
                _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                  _c("img", { attrs: { src: item.descriptImgUrl, alt: "" } })
                ]),
                _vm._v(" "),
                _c("a", { attrs: { href: "#" } }, [
                  _c("img", { attrs: { src: item.imgUrl, alt: "" } }),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(_vm._s(item.itemName) + "X" + _vm._s(item.amount))
                  ])
                ])
              ])
            ],
            1
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [_c("p")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [_c("p")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [_c("p")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [_c("p")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [_c("p")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [_c("p")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [_c("p")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [_c("p")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [_c("p")])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-474c964a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-474c964a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/LuckySpin.vue
// module id = null
// module chunks = 